/* ==========================================================================
   SearcherFli > Client > Utils > Validation
   ========================================================================== */
/* Roundtrip and Oneway */
const validateCalendar = instance => {
    const { calendar } = instance.store.select('data');

    if (!calendar) {
        instance.calendar.actions.setError();

        return false;
    }

    instance.calendar.actions.setValid();

    return true;
};

const validateOrigin = instance => {
    const { origin } = instance.store.select('data');

    if (!origin) {
        instance.origin.actions.setError();

        return false;
    }

    instance.origin.actions.setValid();

    return true;
};

const validateDestination = instance => {
    const { destination } = instance.store.select('data');

    if (!destination) {
        instance.destination.actions.setError();

        return false;
    }

    instance.destination.actions.setValid();

    return true;
};

function validate(instance) {
    if (!instance) {
        throw new Error('You have to provide the reference to the searcher');
    }

    const hasErrors = [
        /* Calendar */
        validateCalendar(instance),

        /* Origin */
        validateOrigin(instance),

        /* Destination */
        validateDestination(instance)
    ].filter(item => !item).length;

    if (hasErrors) {
        return false;
    }

    return true;
}

/* Openjaw validation */

const validateCalendars = instance => {
    const { rows } = instance.store.select('openjaw');

    return rows
        .map((item, index) => {
            const { calendar } = instance.rows[index];

            if (!item.calendar) {
                calendar.actions.setError();

                return false;
            }

            calendar.actions.setValid();

            return true;
        })
        .filter(item => !item);
};

const validateOrigins = instance => {
    const { rows } = instance.store.select('openjaw');

    return rows
        .map((item, index) => {
            const { origin } = instance.rows[index];

            if (!item.origin) {
                origin.actions.setError();

                return false;
            }

            origin.actions.setValid();

            return true;
        })
        .filter(item => !item);
};

const validateDestinations = instance => {
    const { rows } = instance.store.select('openjaw');

    return rows
        .map((item, index) => {
            const { destination } = instance.rows[index];

            if (!item.destination) {
                destination.actions.setError();

                return false;
            }

            destination.actions.setValid();

            return true;
        })
        .filter(item => !item);
};

function validateOpenjaw(instance) {
    if (!instance) {
        throw new Error('You have to provide the reference to the searcher');
    }

    const hasErrors = [
        /* Calendar */
        ...validateCalendars(instance),

        /* Origin */
        ...validateOrigins(instance),

        /* Destination */
        ...validateDestinations(instance)
    ].filter(item => !item).length;

    if (hasErrors) {
        return false;
    }

    return true;
}

/* Exports */
module.exports = {
    validate,
    validateOpenjaw
};
